export function mapMtrRowToAssemblyOption(row) {
  if (!row?.id) {
    return null;
  }

  return {
    optionMtrId: row.id,
    mtrNo: row.mtrNo ?? '',
    name: row.name ?? '',
    status: row.status ?? '',
    // 採購選料等消費端可帶入單價；serializeAssemblyOptions 仍只送 optionMtrId
    baseUnitPrice: row.baseUnitPrice ?? null,
    // 報價選料顯示基礎單位
    baseUnitName: row.baseUnit?.name ?? '',
  };
}

/**
 * detail.assemblyOptions[] → 表單列（含 option_mtr 摘要）
 */
export function parseDetailAssemblyOptions(detail) {
  return (detail?.assemblyOptions ?? [])
    .map((item) => {
      const optionMtr = item?.optionMtr ?? {};
      const optionMtrId = optionMtr.id ?? item?.optionMtrId ?? '';

      if (!optionMtrId) {
        return null;
      }

      return {
        optionMtrId,
        mtrNo: optionMtr.mtrNo ?? '',
        name: optionMtr.name ?? '',
        status: optionMtr.status ?? '',
      };
    })
    .filter(Boolean);
}

/**
 * 表單 assemblyOptions → API assembly_options[]
 */
export function serializeAssemblyOptions(rows = []) {
  return rows
    .filter((row) => row?.optionMtrId)
    .map((row) => ({
      optionMtrId: row.optionMtrId,
    }));
}

export function validateAssemblyOptionsSubmit(values, mode) {
  const messages = [];
  const requiresActiveFields = mode === 'active' || mode === 'activate';

  if (values.mtrKind !== 'GROUP' || !requiresActiveFields) {
    return messages;
  }

  const count = serializeAssemblyOptions(values.assemblyOptions).length;

  if (count < 1) {
    messages.push({
      path: 'assemblyOptions',
      message: '啟用時至少需一筆替代子料',
    });
  }

  return messages;
}
